<div id="modal-dialog modal-dialog-centered">
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title pull-left">{{ title }}</h4>
      <button
        type="button"
        class="close pull-right"
        aria-label="Close"
        *ngIf="!closeOnly"
        (click)="bsModalRef.hide()"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div *ngIf="list.length === 1">
        <!-- added innerHTMl to support HTML tag -->
        <span *ngFor="let item of list"><p [innerHTML]="item"></p></span>
      </div>
      <div *ngIf="list.length > 1">
        <div
          class="custom-control custom-radio"
          *ngFor="let item of list; let adIndex = index"
        >
          <input
            type="radio"
            class="custom-control-input"
            id="ImportAlert{{ adIndex }}"
            name="ImportAlert"
            value="{{ item }}"
            [checked]="adIndex === 0"
            (change)="onTypeChange(item)"
            ngDefaultControl
          />
          <label class="custom-control-label" for="ImportAlert{{ adIndex }}">{{
            item
          }}</label>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer d-flex flex-row align-items-end justify-content-end">
    <button
      type="button"
      class="btn btn-outline-dark justify-self-start"
      *ngIf="!okOnly"
      (click)="close()"
    >
      Cancel
    </button>
    <button type="button" class="{{ btnClass }}" (click)="action()">
      {{ actionButtonText }}
    </button>
  </div>
</div>
